import { render } from "./Respuesta_PlaObs.vue?vue&type=template&id=1c4f512f"
import script from "./Respuesta_PlaObs.vue?vue&type=script&lang=js"
export * from "./Respuesta_PlaObs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__